export default __webpack_public_path__ + "static/media/header1.ffd56dc7.jpg";